import { groq } from "next-sanity";
import { handleClientError } from "../../errors";
import { getClient } from "../sanity";

export type Link = {
  href?: string;
  text?: string;
  blank?: boolean;
};

export type Tile = {
  name: string;
  content: string;
  hightouchDocsLink: string;
  apiDocsLink?: string;
  customLink?: Link;
};

export type DestinationTiles = {
  title: string;
  destinationSlug: string;
  tiles: Tile[];
};

export const getDestinationTiles = async (destinationSlug: string): Promise<DestinationTiles | undefined> => {
  const query = groq`
    *[_type == "destinationTiles" && destination->slug == $destinationSlug] {
      title,
      'destinationSlug': destination->slug,
      'tiles': tiles[]{
        name,
        content,
        hightouchDocsLink,
        apiDocsLink,
        'customLink': customLink{
          href,
          text,
          blank,
        }
      }
    }
  `;

  try {
    const parameters = { destinationSlug };
    const destinationTiles = await getClient().fetch(query, parameters);
    return destinationTiles?.[0] ?? undefined;
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    handleClientError(`Failed to fetch destination tiles for slug "${destinationSlug}": ${message}`);
    return undefined;
  }
};
